
import { Link } from 'react-router-dom';

const MobileBottomBar = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-luxury z-40 lg:hidden">
      <div className="grid grid-cols-3 h-16">
        <a
          href="tel:07530166035"
          className="flex flex-col items-center justify-center border-r border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
        >
          <i className="ri-phone-line text-xl text-charcoal mb-1"></i>
          <span className="text-xs text-charcoal font-medium">Call</span>
        </a>
        
        <a
          href="https://wa.me/447530166035"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center border-r border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
        >
          <i className="ri-whatsapp-line text-xl text-green-600 mb-1"></i>
          <span className="text-xs text-charcoal font-medium">WhatsApp</span>
        </a>
        
        <Link
          to="/contact"
          className="flex flex-col items-center justify-center bg-gold hover:bg-gold-dark transition-colors cursor-pointer"
        >
          <i className="ri-file-list-3-line text-xl text-charcoal mb-1"></i>
          <span className="text-xs text-charcoal font-semibold">Quote</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileBottomBar;
